export const OPTIONAL = 'optional';
export const PREFERRED = 'preferred';
export const MANDATORY = 'mandatory';
export const FILTER = 'filter';

export const additionalCriterionValues = {
    EXCLUDED: '-2',
    ALL_NOT: '-1',
    NATIVE: '1',
    REVERTED_EXCLUDED: '2',
    EXCELLENT: '2',
    BASIC: '3',
};

export const additionalCriterionTextValues = {
    BASIC: 'basic',
    EXCELLENT: 'excellent',
    NATIVE: 'native',
};

export const staticCriteriaFields = {
    industries: 'industries',
    languages: 'languages',
    schools: 'schools',
    skills: 'skills',
};

export const preferredPrioritySupportCriterias = [
    'skills',
    'jobTitles',
    'locations',
    'specialties',
    'companies',
    'companySize',
    'maxCompanySize',
    'schools',
    'educationLevel',
    'industries',
    'yearsOfExperience',
    'maxYearsOfExperience',
    'minimalSeniority',
    'maximalSeniority',
    'averageTenure',
    'maxAverageTenure',
    'managerYearsExperience',
    'maxManagerYearsExperience',
    'languages',
    'jobTitlesAnySeniority',
    'maxJobTitlesAnySeniority',
    'jobTitlesSameSeniority',
    'maxJobTitlesSameSeniority',
    'currentTenure',
    'jobTitlesPast',
];

export default {
    OPTIONAL,
    PREFERRED,
    MANDATORY,
    FILTER,
};
